export const questionPropertyMapper = {
  ง่าย: 'easy',
  กลาง: 'medium',
  ยาก: 'hard',
  คำนวณ: 'calculated',
  ไม่คำนวณ: 'notCalculated',
};

export const DIFFICULTY_TAG_NAME = {
  EASY: 'ง่าย',
  MEDIUM: 'กลาง',
  HARD: 'ยาก',
};
export const CALCULATION_TAG_NAME = {
  CALCULATED: 'คำนวณ',
  NOT_CALCULATED: 'ไม่คำนวณ',
};

export const difficultyTagList = ['ง่าย', 'กลาง', 'ยาก'];
export const calculationTagList = ['คำนวณ', 'ไม่คำนวณ'];

// TODO: Promote to config variable when config can change without redeploy
export const ITEM_SET_QUESTION_SIZE = {
  MIN: 2,
  MAX: 5,
};
